export class Account {
    accountId : number;
    name : string;

    constructor() {
        this.accountId = 0;
        this.name = "";
    }
}